import { useTypedAppFormContext } from '@/components/Form';

import type { FilterFormValues } from './filterFormApi';

export function useFilterForm() {
  return useTypedAppFormContext({ defaultValues: {} as FilterFormValues });
}
